import styled from 'styled-components';

export const CardContainer = styled.div`
  position: relative;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  cursor: pointer;
  padding: 10px 10px;
  user-select: none;
  background: ${({ $isDragging, $isSelected }) =>
    $isDragging ? '#f0f8ff' : $isSelected ? '#fffbf0' : '#fff'};
  border-left: 4px solid
    ${({ $isWarning, $statusColor }) =>
      $isWarning ? '#FFA500' : $statusColor || 'transparent'};
  transition: transform 0.15s ease;
  will-change: transform;
  ${({ $isPressed, $isDragging }) =>
    $isPressed &&
    !$isDragging &&
    `
      transform: rotate(-3deg);
      cursor: grabbing;
    `}

  ${({ $isDragging }) =>
    $isDragging &&
    `
      transform: rotate(0deg) !important;
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.15);
      z-index: 9999;
    `}
  z-index: ${({ $isDropdownOpen }) => ($isDropdownOpen ? '9999' : '1')};

  &:focus-within {
    z-index: 9999;
  }
  perspective: 1000px;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
`;

export const CompanyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const CheckBoxBlock = styled.label`
  width: 26px;
  height: 26px;
  background: #f1f5f9;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: pointer;
  padding: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e2e8f0;
  }
`;

export const RightCheckbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
  cursor: pointer;
  border: 1px solid #0000001a;
  background: #f3f3f5;
  box-shadow: 0px 0.65px 1.3px 0px #0000000d;
  accent-color: #2d6cdf;
  flex-shrink: 0;
  border-radius: 3px;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    border-color: #2d6cdf;
  }

  &:checked {
    background-color: #2d6cdf;
    border-color: #2d6cdf;
  }
  &:checked::after {
    content: '';
    width: 2px;
    height: 5px;
    border: solid white;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
    position: absolute;
    top: -0.5px;
    left: 2.5px;
  }
`;

export const CardContent = styled.div`
  padding: 0;
`;

export const CompanyName = styled.h4`
  font-size: 14px;
  font-weight: 700;
  color: #1d293d;
  margin: 4px 0 8px 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const PriorityTag = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${({ $priority }) => {
    switch ($priority?.toLowerCase()) {
      case 'high':
        return '#fee2e2';
      case 'medium':
        return '#fef3c7';
      case 'low':
        return '#dbeafe';
      case 'new':
        return '#e0e7ff';
      default:
        return '#f3f4f6';
    }
  }};
  color: ${({ $priority }) => {
    switch ($priority?.toLowerCase()) {
      case 'high':
        return '#dc2626';
      case 'medium':
        return '#f59e0b';
      case 'low':
        return '#3b82f6';
      case 'new':
        return '#6366f1';
      default:
        return '#6b7280';
    }
  }};
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const InfoImg = styled.img``;

export const InfoText = styled.span`
  font-size: 11px;
  color: #62748e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .assign-to {
    color: #296bcd;
  }
`;

export const CardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const CompanyText = styled.div`
  font-weight: 700;
  font-size: 9px;
  text-transform: uppercase;
  color: #90a1b9;
  padding-top: 3px;
`;
export const BuildingIcon = styled.img`
  width: 13px;
  height: 13px;
  mask-image: url(${({ $src }) => $src});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-image: url(${({ $src }) => $src});
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: ${({ $isWarning, $statusColor }) =>
    $isWarning ? '#FFA500' : $statusColor || '#90a1b9'};
`;
export const WarningBadge = styled.div`
  position: absolute;
  right: ${({ $offset }) => ($offset ? `${$offset}px` : '-8px')};
  width: 20px;
  height: 20px;
  background-color: ${({ $type }) =>
    $type === 'warning' || $type === 'no-offer' ? '#FE9A00' : 'transparent'};
  border-radius: 50%;
  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const WarningImg = styled.img`
  padding-bottom: 1px;
`;

export const HoverText = styled.span`
  position: absolute;
  bottom: -19px;
  right: 15px;

  background: #1f2937;
  color: #fff;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;

  opacity: 0;
  visibility: hidden;
  transform: translateY(5px);
  transition: 0.2s ease;
`;

export const WarningWrapper = styled.div`
  position: relative;
  display: inline-flex;

  &:hover span {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;
